export const destinationIconByType = {
  'o-rtsp-0': 'icon-a-rtsppull2',
  'o-rtsp-1': 'icon-a-rtsppush',
  'o-rtmp-0': 'icon-a-rtmppull2',
  'o-rtmp-1': 'icon-a-rtmppush2',
  'o-udp-1': 'icon-a-udp2',
  'srt-0': 'icon-a-SRTcaller2',
  'srt-1': 'icon-a-SRTlistener2',
  f: 'icon-facebook11',
  i: 'icon-instagram11',
  // z: '&#xe6a8',
  y: 'icon-youtubeauto',
  // twitter: '&#xe78a',
  t: 'icon-twitch1',
  k: 'icon-kuaishou2',
  vimeo: 'icon-a-vimeo3',
  'hls-0': 'icon-a-hlspull2',
  'hls-1': 'icon-a-hlspush2',
  prompeg: 'icon-a-rtp5',
  'rtp-fec': 'icon-a-rtp5',
  zixi: 'icon-output-zixi',
  issp: 'icon-a-isspgrid2',
  grid: 'icon-a-grid2',
  ndi: 'icon-a-NDI2',
  // rtil: '&#xe727',
  sdi: 'icon-a-SDI2',
  twitter: 'icon-x2',
  mxl: 'icon-a-mxl21',
  other: 'icon-a-otheroutput2'
}
export const destinationLabelByType = {
  'o-rtsp-0': 'RTSP Pull',
  'o-rtsp-1': 'RTSP Push',
  'o-rtmp-0': 'RTMP(S) Pull',
  'o-rtmp-1': 'RTMP(S) Push',
  'o-udp-1': 'UDP',
  'srt-0': 'SRT Caller',
  'srt-1': 'SRT Listener',
  f: 'Facebook',
  // i: 'Instagram',
  // z: '&#xe6a8',
  y: 'YouTube',
  t: 'Twitch',
  // k: 'KuaiShou',
  // vimeo: 'icon-a-vimeo3', //
  'hls-0': 'HLS Pull',
  'hls-1': 'HLS Push',
  // prompeg: 'ProMPEG',
  prompeg: 'RTP-FEC',
  'rtp-fec': 'RTP-FEC',
  // zixi: 'Zixi',
  issp: 'ISSP',
  grid: 'Grid',
  ndi: 'NDI',
  // rtil: '&#xe727',
  sdi: 'SDI',
  twitter: 'X',
  other: 'OTHER'
}
export const MediaTypeList = {
  F: 'Facebook',
  I: 'Instagram',
  Y: 'YouTube',
  Twitter: 'Twitter',
  T: 'Twitch',
  K: 'KuaiShou',
  Vimeo: 'Vimeo',
  O: {
    // 'Others',
    default: 'Others',
    RTMP: 'RTMP(S)',
    UDP: 'UDP',
    RTSP: 'RTSP'
  },
  HLS: 'HLS',
  ISSP: 'ISSP',
  // PROMPEG: 'ProMPEG',
  PROMPEG: 'RTP-FEC',
  'RTP-FEC': 'RTP-FEC',
  SRT: 'SRT',
  Zixi: 'ZiXi',
  NDI: 'NDI',
  Grid: 'GridName',
  Channel: 'ChannelName',
  RTIL: 'RTILName'
}
export const environmentList = {
  mediahub08: 'MediaHubMonday',
  mediahub09: 'MediaHubTuesday',
  mediahub10: 'MediaHubWednesday',
  mediahub11: 'MediaHubThursday',
  mediahub12: 'MediaHubFriday',
  mediahub06: 'MediaHubProd1',
  mediahub07: 'MediaHubProd2',
  mediahub13: 'MediaHubProd3',
  mediahub15: 'MediaHubProd4',
  mediahub16: 'MediaHubProd5',
  mediahub17: 'MediaHubProd6',
  mediahub18: 'MediaHubProd7',
  mediahub19: 'MediaHubProd8',
  mediahub21: 'MediaHubProd9',
  mediahub14: 'MediaHubSpecial1',
  mediahub04: 'MediaHubSpecial2'
}

export const sourceLabelByType = {
  pack: 'TVU Pack',
  anywhere: 'TVU Anywhere',
  grid_sdi: 'TVU Grid-SDI',
  grid_pack: 'TVU Grid-Pack',
  grid_mediahub: 'TVU Grid-MediaHub',
  ndi: 'NDI',
  hls: 'HLS',
  zoom: ' Zoom Meeting',
  facebook: 'Facebook',
  tiktok: 'Tiktok',
  twitch: 'Twitch',
  twitter: 'X',
  kick: 'Kick',
  youtube: 'YouTube',
  ext: 'Ext',
  smpte2022: 'Smpte2022',
  issp: 'ISSP',
  udp: 'UDP',
  sdi: 'SDI',
  rtp: 'RTP-FEC',
  zixi: 'Zixi',
  html: 'HTML',
  rtsppush: 'RTSP Push',
  rtsppull: 'RTSP Pull',
  rtsp: 'RTSP Pull',
  rtmppush: 'RTMP(S) Push',
  rtmppull: 'RTMP(S) Pull',
  rtmp: 'RTMP(S) Pull',
  srtlistener: 'SRT Listener',
  srtcaller: 'SRT Caller',
  srt: 'SRT Caller',
  mxl: 'MXL'
}

export const sourceIconByType = {
  anywhere: 'icon-anywhere',
  pack: 'icon-icon_pack',
  grid_sdi: 'icon-a-gridsdi',
  grid_pack: 'icon-a-gridpack',
  grid_mediahub: 'icon-MediaHub',
  srtlistener: 'icon-a-inputSRTlistener',
  srt_listener: 'icon-a-inputSRTlistener',
  srtcaller: 'icon-a-inputSRTcaller',
  srt_caller: 'icon-a-inputSRTcaller',
  srt: 'icon-a-inputSRTcaller',
  rtmppush: 'icon-a-inputRTMPpush',
  rtmp_push: 'icon-a-inputRTMPpush',
  rtmppull: 'icon-a-inputRTMPpull',
  rtmp_pull: 'icon-a-inputRTMPpull',
  rtmp: 'icon-a-inputRTMPpull',
  rtsppush: 'icon-a-inputrtsppush',
  rtsp_push: 'icon-a-inputrtsppush',
  rtsppull: 'icon-a-inputrtsppull',
  rtsp_pull: 'icon-a-inputrtsppull',
  rtsp: 'icon-a-inputrtsppull',
  ext: 'icon-config-ip',
  smpte2022: 'icon-config-ip',
  youtube: 'icon-a-inputyoutube',
  zixi: 'icon-Zixi',
  mxl: 'icon-mxl',
  hls: 'icon-a-inputhlspull',
  rtp: 'icon-RTP-FEC',
  udp: 'icon-a-inputudp',
  ndi: 'icon-NDI1',
  sdi: 'icon-sdi',
  html: 'icon-HTML',
  zoom: 'icon-a-inputzoom',
  issp: 'icon-ISSP',
  facebook: 'icon-Facebook',
  tiktok: 'icon-a-inputtiktok',
  twitch: 'icon-twitch3',
  twitter: 'icon-x',
  kick: 'icon-kick1'
}

export const sourceImgByType = {
  anywhere: 'icon-anywhere1',
  pack: 'icon-pack',
  grid_sdi: 'icon-grid-sdi',
  grid_pack: 'icon-grid-pack',
  grid_mediahub: 'icon-Grid-mediahub',
  srtlistener: 'icon-a-srtlistener',
  srtcaller: 'icon-a-srtcaller',
  srt: 'icon-a-srtcaller',
  rtsppush: 'icon-RTSP-PUSH',
  rtsppull: 'icon-RTSP-PULL',
  rtsp: 'icon-RTSP-PULL',
  rtmppush: 'icon-a-rtmppush',
  rtmppull: 'icon-a-rtmppull',
  rtmp: 'icon-a-rtmppull',
  ext: 'icon-External',
  smpte2022: 'icon-External',
  youtube: 'icon-youtube1',
  zixi: 'icon-zixi',
  mxl: 'icon-MXL',
  hls: 'icon-HLS',
  rtp: 'icon-RTP-FEC1',
  udp: 'icon-UDP1',
  ndi: 'icon-NDI',
  sdi: 'icon-SDI',
  html: 'icon-HTML1',
  zoom: 'icon-zoom',
  issp: 'icon-ISSP1',
  facebook: 'icon-facebook',
  tiktok: 'icon-tiktok1',
  twitch: 'icon-twitch2',
  twitter: 'icon-x3',
  kick: 'icon-kick'
}

export const ODestIconByType = {
  rtsppull: 'icon-a-rtsppull2',
  rtsppush: 'icon-a-rtsppush',
  rtmppull: 'icon-a-rtmppull2',
  rtmppush: 'icon-a-rtmppush2',
  udp: 'icon-a-udp2',
  srtcaller: 'icon-a-SRTcaller2',
  srtlistener: 'icon-a-SRTlistener2',
  facebook: 'icon-facebook11',
  // i: 'icon-instagram11',
  youtube: 'icon-youtubeauto',
  twitch: 'icon-twitch1',
  kuaishou: 'icon-kuaishou2',
  // vimeo: 'icon-a-vimeo3',
  hlspull: 'icon-a-hlspull2',
  hlspush: 'icon-a-hlspush2',
  prompeg: 'icon-a-rtp5',
  'rtp-fec': 'icon-a-rtp5',
  zixi: 'icon-output-zixi',
  issp: 'icon-a-isspgrid2',
  grid: 'icon-a-grid2',
  ndi: 'icon-a-NDI2',
  sdi: 'icon-a-SDI2',
  x: 'icon-x2', // Twitter
  mxl: 'icon-a-mxl21',
  pack: 'icon-a-tvupack2',
  other: 'icon-a-otheroutput2'
}
export const ODestLabelByType = {
  rtsppull: 'RTSP Pull',
  rtsppush: 'RTSP Push',
  rtmppull: 'RTMP(S) Pull',
  rtmppush: 'RTMP(S) Push',
  udp: 'UDP',
  srtcaller: 'SRT Caller',
  srtlistener: 'SRT Listener',
  facebook: 'Facebook',
  // i: 'Instagram',
  // z: '&#xe6a8',
  youtube: 'YouTube',
  twitch: 'Twitch',
  // k: 'KuaiShou',
  // vimeo: 'icon-a-vimeo3', //
  hlspull: 'HLS Pull',
  hlspush: 'HLS Push',
  prompeg: 'RTP-FEC',
  // prompeg: 'ProMPEG',
  'rtp-fec': 'RTP-FEC',
  zixi: 'Zixi',
  issp: 'ISSP',
  grid: 'Grid',
  ndi: 'NDI',
  // rtil: '&#xe727',
  sdi: 'SDI',
  x: 'X',
  mxl: 'MXL',
  pack: 'TVU Pack',
  other: 'Other'
}

// 不支持 IP 标签显示的源类型 [Claude Code]
export const excludeType = ['SDI', 'NDI']

// 基础源类型列表，用于判断是否显示快速配置相关功能 [Claude Code]
export const baseSourceTypeList = ['quick-setup', 'HLS', 'UDP', 'RTP', 'Zixi', 'YouTube', 'Facebook', 'tiktok', 'Ext', 'ISSP', 'HTML', 'Twitch', 'Twitter', 'Kick']

// 支持 IP 标签显示的源类型标签列表 [Claude Code]
export const supportIpLabelList = ['SRT Listener', 'SRT Caller', 'RTMP(S) Pull', 'RTSP Pull', 'HLS', 'UDP', 'Zixi', 'ISSP', 'MXL', 'other']

// 可选源类型完整列表，含 sourceLabel/sourceType/sourceKey [Claude Code]
export const sourceTypeList = [
  { sourceLabel: 'quickSetup', sourceType: 'quick-setup', sourceKey: 'quick-setup' },
  { sourceLabel: 'tvuDevice', sourceType: 'tvu-device', sourceKey: 'tvu-device' },
  { sourceLabel: 'ISSP', sourceType: 'Ext', sourceKey: 'issp' },
  { sourceLabel: 'SDI', sourceType: 'SDI', sourceKey: 'sdi' },
  // SRT Listener 排在 Caller 前面，引导用户优先选择 Listener (MH-2452) [Claude Code]
  { sourceLabel: 'SRT Listener', sourceType: 'SRT', sourceKey: 'srtlistener' },
  { sourceLabel: 'SRT Caller', sourceType: 'SRT', sourceKey: 'srt,srtcaller' },
  { sourceLabel: 'HLS', sourceType: 'HLS', sourceKey: 'hls' },
  { sourceLabel: 'RTMP(S) Push', sourceType: 'RTMP', sourceKey: 'rtmppush' },
  { sourceLabel: 'RTMP(S) Pull', sourceType: 'RTMP', sourceKey: 'rtmp,rtmppull' },
  { sourceLabel: 'RTSP Push', sourceType: 'RTSP', sourceKey: 'rtsppush' },
  { sourceLabel: 'RTSP Pull', sourceType: 'RTSP', sourceKey: 'rtsp,rtsppull' },
  { sourceLabel: 'HTML', sourceType: 'HTML', sourceKey: 'html' },
  { sourceLabel: 'NDI', sourceType: 'NDI', sourceKey: 'ndi' },
  { sourceLabel: 'UDP', sourceType: 'UDP', sourceKey: 'udp' },
  { sourceLabel: 'zoom', sourceType: 'ZOOM', sourceKey: 'zoom' },
  { sourceLabel: 'RTP-FEC', sourceType: 'RTP', sourceKey: 'rtp' },
  { sourceLabel: 'MXL', sourceType: 'MXL', sourceKey: 'mxl' },
  { sourceLabel: 'YouTube', sourceType: 'YouTube', sourceKey: 'youtube' },
  { sourceLabel: 'Facebook', sourceType: 'Facebook', sourceKey: 'facebook' },
  { sourceLabel: 'tiktok', sourceType: 'Ext', sourceKey: 'tiktok' },
  { sourceLabel: 'Twitch', sourceType: 'Twitch', sourceKey: 'twitch' },
  { sourceLabel: 'X', sourceType: 'Twitter', sourceKey: 'twitter' },
  { sourceLabel: 'Kick', sourceType: 'Kick', sourceKey: 'kick' },
  { sourceLabel: 'other', sourceType: 'Ext', sourceKey: 'ext' }
]

export default {
  destinationIconByType,
  MediaTypeList,
  environmentList,
  destinationLabelByType,
  sourceLabelByType,
  sourceIconByType,
  sourceImgByType,
  ODestIconByType,
  ODestLabelByType,
  excludeType,
  baseSourceTypeList,
  supportIpLabelList,
  sourceTypeList
}
